import { useMutation } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { SequenceMenu } from '@sequencehq/core-components'
import { useNotifications } from '@sequencehq/core-components'

export const useCreateQuoteFromTemplate = (props: {
  quoteTemplateId: string
  onSuccess?: (newQuoteId: string) => void
}) => {
  const { displayPromiseNotification } = useNotifications()
  const createQuoteMutation = useMutation(
    dashboard20240730Client.postCreateQuoteFromTemplate
  )
  return {
    createQuoteFromTemplate: async () => {
      try {
        const newQuoteRes = await displayPromiseNotification(
          createQuoteMutation.mutateAsync({
            id: props.quoteTemplateId
          }),
          {
            loading: 'Creating quote from template',
            success: 'Quote created',
            error: 'Failed to create quote from template'
          }
        )

        if (!newQuoteRes || !newQuoteRes.id) {
          return false
        }

        props.onSuccess?.(newQuoteRes.id)
        return true
      } catch {
        return false
      }
    },
    creationInProgress: createQuoteMutation.isPending
  }
}

export const CreateQuoteFromTemplateMenuItem = (props: {
  quoteTemplateId: string
  disabled?: boolean
  onSuccess?: (newQuoteId: string) => void
}) => {
  const { createQuoteFromTemplate } = useCreateQuoteFromTemplate({
    quoteTemplateId: props.quoteTemplateId,
    onSuccess: props.onSuccess
  })
  return (
    <SequenceMenu.Item
      uuid="create-quote-from-template"
      label="Create quote from template"
      data-testid={`quoteTemplates.${props.quoteTemplateId}.menuItem.createQuote`}
      isDisabled={props.disabled}
      onClick={createQuoteFromTemplate}
    />
  )
}
